"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyElementsSearchBar = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
/**
 * This component render empty ElementsSearchBar
 * @internal
 */
exports.EmptyElementsSearchBar = function (_props) {
    return react_1.default.createElement("div", { className: "gd-empty-select-search-bar" });
};
//# sourceMappingURL=EmptyElementsSearchBar.js.map